module.exports = __webpack_public_path__ + "img/Maleki.9d9512a7.jpg";